import {Injectable} from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PopoverManagerService {
    private closeAllPopovers$ = new Subject<void>();
    private activePopoverId: string;

    get closeAllPopovers() {
        return this.closeAllPopovers$.asObservable();
    }

    public setActivePopover(id: string) {
        this.activePopoverId = id;
        this.closeAllPopovers$.next();
    }

    public getActivePopoverId() {
        return this.activePopoverId;
    }

    constructor() {
    }
}
